import { render, staticRenderFns } from "./Privacys.vue?vue&type=template&id=636cc67a&scoped=true&"
import script from "./Privacys.vue?vue&type=script&lang=js&"
export * from "./Privacys.vue?vue&type=script&lang=js&"
import style0 from "./Privacys.vue?vue&type=style&index=0&id=636cc67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636cc67a",
  null
  
)

export default component.exports